<template>
  <div class="zbpt">
    <section class="hero">
      <div class="w1280">
        <div class="hero-inner">
          <div class="hero-title">闽江智能数据标注产业基地</div>
          <div class="hero-desc">
            聚焦多模态数据标注与产业协同，提供高质量、可追溯、可规模化交付的数据服务能力，帮助企业更快完成模型训练与应用落地。
          </div>
          <div class="hero-actions">
            <div class="btn btn-primary" @click="go('/callMe')">立即咨询</div>
            <div class="btn btn-ghost" @click="scrollToSection('partner')">成为合作伙伴</div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="w1280">
        <div class="section-title">我们的服务与资质</div>
        <div class="section-subtitle">
          作为行业领先的数据标注服务提供商，我们拥有完善的解决方案和丰富的行业经验。
        </div>
        <div class="card-grid card-grid-3">
          <div class="info-card" v-for="(item, index) in serviceList" :key="index">
            <div class="card-title">{{ item.title }}</div>
            <img class="service-img" :src="item.img" :alt="item.title" />
            <div class="card-text">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </section>

    <section class="section section-soft">
      <div class="w1280">
        <div class="section-title">为什么选择与我们合作</div>
        <div class="section-subtitle">
          深度匹配垂直行业需求，以质量、安全、效率与服务保障项目全流程交付。
        </div>
        <div class="card-grid card-grid-4">
          <div class="adv-card" v-for="(item, index) in advantageList" :key="index">
            <img class="adv-icon" :src="item.img" :alt="item.title" />
            <div class="adv-content">
              <div class="adv-title">{{ item.title }}</div>
              <div class="adv-text">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section" id="partner">
      <div class="w1280">
        <div class="section-title">成为我们的合作伙伴</div>
        <div class="section-subtitle">
          根据您的情况选择合适的合作方式，开启合作之旅。
        </div>
        <div class="partner-grid">
          <div class="partner-card" v-for="(item, index) in partnerList" :key="index">
            <div class="card-title">{{ item.title }}</div>
            <ul class="feature-list">
              <li v-for="(feature, fIndex) in item.features" :key="fIndex">
                {{ feature }}
              </li>
            </ul>
            <a
              class="btn btn-primary partner-btn"
              href="https://alidocs.dingtalk.com/notable/share/form/v01meonarboYV9apqXx_dv19yqvsgs3oebp3pcjys_1qX0QQ0"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ item.action }}
            </a>
          </div>
        </div>
      </div>
    </section>

    <section class="footer-cta">
      <div class="w1280">
        <div class="cta-title">高质量数据，助力高质量模型</div>
        <div class="cta-desc">从数据安全到交付质量，提供覆盖全周期的专业服务支持。</div>
        <div class="btn btn-primary" @click="go('/callMe')">联系团队</div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Zbpt",
  data() {
    return {
      serviceList: [
        {
          title: "人工智能数据标注服务",
          img: require("../assets/img/zbpt/annotation.png"),
          content:
            "提供图像、文本、语音等多场景标注方案，以高标注精度、灵活交付周期与严格保密机制，帮助企业快速获得高质量训练数据。",
        },
        {
          title: "信息安全管理体系",
          img: require("../assets/img/zbpt/sercure.jpg"),
          content:
            "建立制度规范与技术手段协同的安全体系，覆盖风险预警、应急处置与人员安全培训，确保数据处理过程全程可控。",
        },
        {
          title: "企业数据隐私保护",
          img: require("../assets/img/zbpt/privacy.jpg"),
          content:
            "按红黄蓝分区管控核心数据、敏感数据与普通数据，结合权限隔离和加密策略，降低数据泄露风险。",
        },
      ],
      advantageList: [
        {
          title: "严格的数据安全保障",
          content: "完善的数据安全管理机制，确保数据处理全流程可审计、可追踪、可管控。",
          img: require("../assets/img/zbpt/safe.png"),
        },
        {
          title: "高质量标注标准",
          content: "专业质检团队与多级审核流程，保障数据一致性、准确率与可用性。",
          img: require("../assets/img/zbpt/protect.png"),
        },
        {
          title: "高效的交付能力",
          content: "成熟项目管理流程与协同机制，确保按时按质完成交付目标。",
          img: require("../assets/img/zbpt/project.png"),
        },
        {
          title: "专业的支持团队",
          content: "丰富行业经验与快速响应机制，及时解决合作过程中的关键问题。",
          img: require("../assets/img/zbpt/team.png"),
        },
      ],
      partnerList: [
        {
          title: "众包注册",
          features: ["灵活的工作时间和地点", "按任务结算，多劳多得", "提供专业培训和指导"],
          action: "立即注册",
        },
        {
          title: "供应商注册",
          features: ["长期稳定的合作关系", "批量任务分配，保证收益", "技术支持与资源共享"],
          action: "立即注册",
        },
      ],
    };
  },
  methods: {
    go(path) {
      this.$router.push(path);
    },
    scrollToSection(id) {
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.zbpt {
  color: #25282a;
  background: #ffffff;
}

.w1280 {
  width: 1280px;
  margin: 0 auto;
}

.hero {
  background: linear-gradient(130deg, #eaf7ff 0%, #f6fbff 45%, #eef2ff 100%);
  border-bottom: 1px solid #e8eef7;
}

.hero-inner {
  padding: 92px 0 84px;
  text-align: center;
}

.hero-title {
  color: #045588;
  font-size: 52px;
  line-height: 1.2;
  font-weight: 700;
}

.hero-desc {
  width: 860px;
  margin: 28px auto 0;
  color: rgba(75, 79, 84, 0.92);
  font-size: 20px;
  line-height: 1.8;
}

.hero-actions {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  gap: 16px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  border-radius: 8px;
  padding: 0 24px;
  font-size: 16px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  user-select: none;
}

.btn:hover {
  transform: translateY(-1px);
}

.btn-primary {
  color: #fff;
  background-image: linear-gradient(260deg, #099fee 4%, #2247da 143%);
  box-shadow: 0 10px 24px rgba(34, 71, 218, 0.2);
}

.btn-ghost {
  color: #045588;
  border: 1px solid #b8d6f0;
  background: #ffffff;
}

.section {
  padding: 72px 0;
}

.section-soft {
  background: #f8fbff;
}

.section-title {
  text-align: center;
  color: #045588;
  font-size: 46px;
  font-weight: 700;
  line-height: 1.3;
}

.section-subtitle {
  width: 860px;
  margin: 16px auto 0;
  text-align: center;
  color: #4b4f54;
  font-size: 18px;
  line-height: 1.7;
}

.card-grid {
  margin-top: 42px;
  display: grid;
  gap: 24px;
  align-items: start;
}

.card-grid-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.card-grid-4 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  max-width: 980px;
  margin-left: auto;
  margin-right: auto;
}

.info-card,
.adv-card,
.partner-card {
  background: #fff;
  border: 1px solid #e6edf5;
  border-radius: 16px;
  padding: 28px 24px;
  box-shadow: 0 8px 26px rgba(26, 64, 96, 0.06);
}

.info-card {
  display: flex;
  flex-direction: column;
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.info-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 30px rgba(26, 64, 96, 0.12);
}

.card-title {
  font-size: 24px;
  line-height: 1.4;
  color: #045588;
  font-weight: 600;
  margin-bottom: 14px;
  text-align: center;
}

.service-img {
  width: 100%;
  height: 190px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: 16px;
  border: 1px solid #edf3f9;
}

.card-text {
  font-size: 16px;
  line-height: 1.85;
  color: #4b4f54;
  margin-top: 0;
}

.adv-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  min-height: 88px;
  position: relative;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}

.adv-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 26px rgba(26, 64, 96, 0.14);
  border-color: #c8def3;
}

.adv-icon {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  object-fit: contain;
  transition: transform 0.25s ease;
}

.adv-card:hover .adv-icon {
  transform: scale(1.08);
}

.adv-content {
  min-width: 0;
}

.adv-title {
  color: #1e2b3b;
  font-size: 20px;
  line-height: 1.35;
  font-weight: 600;
  transition: color 0.25s ease;
}

.adv-text {
  margin-top: 2px;
  color: #4b4f54;
  font-size: 14px;
  line-height: 1.5;
  transition: color 0.25s ease;
}

.adv-card:hover .adv-title {
  color: #0f4f84;
}

.adv-card:hover .adv-text {
  color: #3e4952;
}

.partner-grid {
  margin-top: 42px;
  display: grid;
  grid-template-columns: repeat(2, minmax(320px, 420px));
  gap: 18px;
  justify-content: center;
  max-width: 920px;
  margin-left: auto;
  margin-right: auto;
}

.partner-card {
  padding: 22px 20px;
  min-height: 248px;
  text-align: center;
}

.partner-btn {
  width: 120px;
  margin-top: 6px;
  text-decoration: none !important;
}

.partner-btn:hover {
  text-decoration: none !important;
}

.feature-list {
  margin: 12px 0 18px;
  padding-left: 0;
  list-style: none;
}

.feature-list li {
  color: #4b4f54;
  font-size: 16px;
  line-height: 1.9;
}

.footer-cta {
  padding: 64px 0 76px;
  text-align: center;
  background: linear-gradient(70deg, rgba(124, 208, 255, 0.2) 7%, #f0efea 88%);
}

.cta-title {
  color: #045588;
  font-size: 46px;
  line-height: 1.3;
  font-weight: 700;
}

.cta-desc {
  margin-top: 16px;
  font-size: 18px;
  color: #4b4f54;
}

.footer-cta .btn {
  margin: 32px auto 0;
  width: 128px;
}

@media (max-width: 1360px) {
  .w1280 {
    width: calc(100% - 48px);
  }
  .hero-desc,
  .section-subtitle {
    width: 100%;
  }
}

@media (max-width: 992px) {
  .hero-title {
    font-size: 40px;
  }
  .section-title,
  .cta-title {
    font-size: 34px;
  }
  .card-grid-3 {
    grid-template-columns: 1fr;
  }
  .card-grid-4 {
    grid-template-columns: 1fr;
  }
  .partner-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .w1280 {
    width: calc(100% - 28px);
  }
  .hero-inner {
    padding: 64px 0;
  }
  .hero-title {
    font-size: 30px;
  }
  .hero-desc {
    font-size: 16px;
    line-height: 1.7;
  }
  .hero-actions {
    flex-direction: column;
  }
  .btn {
    width: 100%;
  }
  .section {
    padding: 56px 0;
  }
  .section-title,
  .cta-title {
    font-size: 28px;
  }
  .section-subtitle,
  .cta-desc {
    font-size: 16px;
  }
  .card-grid-4 {
    grid-template-columns: 1fr;
  }
  .card-title {
    font-size: 20px;
  }
}
</style>
